var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "spinner spinner--rotate-diamond", style: _vm.styles },
    [
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }